import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=71f1e876&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=ts&"
export * from "./loader.vue?vue&type=script&lang=ts&"
import style0 from "./loader.vue?vue&type=style&index=0&id=71f1e876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f1e876",
  null
  
)

export default component.exports